import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Zendesk Create Ticket v1 Configuration Validator
 * Validates Zendesk ticket creation configuration
 */
export const Zendesk_Create_Ticket_1_ConfigValidator = z.object({
    zendeskConnection: requiredString('Zendesk Connection is required'),
    subject: requiredString('Ticket Subject is required'),
    description: requiredString('Ticket Description is required'),
    requesterName: z.string().optional(),
    requesterEmail: z.string().optional(),
    brandId: z.string().optional(),
    assigneeId: z.string().optional(),
    groupId: z.string().optional(),
    ticketFormId: z.string().optional(),
    status: z.enum(['new', 'open', 'pending', 'hold', 'solved', 'closed']).nullable().optional(),
    customFields: z.record(z.string(), z.any()).optional()
});
//# sourceMappingURL=zendesk-create-ticket-1.js.map